import { css } from '@emotion/react';
import { RadioButtonRow, space } from 'folio-common-components';
import * as React from 'react';
import { MultiOwnershipSection } from '../../routes/step3/MultiOwnershipSection';
import { SingleCompanyOwnerSection } from '../../routes/step3/SingleCompanyOwnerSection';
import { useActions, useSelector } from '../../state';
import { selectors as editorSelectors } from '../../state/editor';

export const FoundingTypeForm: React.FC = () => {
  const { editorThunks } = useActions();
  const ownershipType = useSelector(e => e.editor.ownershipType);
  const singleCompanyOwner = useSelector(e => {
    return editorSelectors.getCompanyOwner(
      e,
      e.editor.singleCompanyOwner?.orgId,
    );
  });

  return (
    <>
      <RadioButtonRow
        inputProps={{
          checked: ownershipType === 'single',
          onChange: () => editorThunks.toggleOwnershipType('single'),
          name: 'foundingType',
        }}
        id="single"
        label="Kun meg"
      />
      <RadioButtonRow
        inputProps={{
          checked: ownershipType === 'company',
          onChange: () => editorThunks.toggleOwnershipType('company'),
          name: 'foundingType',
        }}
        id="company"
        label="Et selskap"
      />
      {ownershipType === 'company' && (
        <div
          css={css`
            ${space([16], 'margin-top')};
          `}
        >
          <SingleCompanyOwnerSection owner={singleCompanyOwner} />
        </div>
      )}
      <RadioButtonRow
        inputProps={{
          checked: ownershipType === 'multiple',
          onChange: () => editorThunks.toggleOwnershipType('multiple'),
          name: 'foundingType',
        }}
        id="multiple"
        label="Flere personer eller selskaper"
      />
      {ownershipType === 'multiple' && <MultiOwnershipSection />}
    </>
  );
};
